import { TeacherPaymentResponse } from '@/app/models/teacherPayment';
import {
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const HeaderTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 13,
  fontWeight: 'bold',
  padding: theme.spacing(2),
}));

const RowTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 12,
  padding: theme.spacing(2),
}));

type TeacherPaymentTableParams = {
  rows: TeacherPaymentResponse[];
  count: number;
  rowsPerPage: number;
  setRowsPerPage: (n: number) => void;
  page: number;
  setPage: (n: number) => void;
};

const formatter = new Intl.NumberFormat('pt-BR');
const formatterMonetaryValue = (value: any) => `${formatter.format(value)}`;

export default function TeacherPaymentTable(props: TeacherPaymentTableParams) {
  const { t } = useTranslation(['event', 'common']);
  const { rows, count, rowsPerPage, setRowsPerPage, page, setPage } = props;

  return (
    <TableContainer sx={{ marginLeft: 0, padding: 0, width: '100%' }}>
      <Table sx={{ tableLayout: 'fixed', width: '100%' }}>
        <TableHead>
          <TableRow>
            <HeaderTableCell>{t('common:collaborator')}</HeaderTableCell>
            <HeaderTableCell>{t('common:resource.badge')}</HeaderTableCell>
            <HeaderTableCell>{t('Cod.CR')}</HeaderTableCell>
            <HeaderTableCell colSpan={3} align="left">
              {t('common:value')}
            </HeaderTableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{ tableLayout: 'fixed', width: '100%' }}>
          {rows.map((row, index = 0) => (
            <TableRow key={row.professorName + index}>
              <RowTableCell>{row.professorName}</RowTableCell>
              <RowTableCell>{row.professorBadge}</RowTableCell>
              <RowTableCell>{row.projectCode}</RowTableCell>
              <RowTableCell colSpan={3} align="left">{`R$ ${formatterMonetaryValue(
                row.paymentValue,
              )}`}</RowTableCell>
            </TableRow>
          ))}
          {rows.length === 0 && (
            <TableRow>
              <TableCell sx={{ textAlign: 'center' }} colSpan={6}>
                <Typography variant="subtitle2">
                  {t('common:no.data.for.the.chosen.period.and.search.term')}
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination
        sx={{ width: '100%' }}
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={count || 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(e, p) => setPage(p)}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
        labelDisplayedRows={({ from, to, count: tcount }) => `${from}-${to} ${t('de')} ${tcount}`}
        labelRowsPerPage={t('common:items.per.page')}
      />
    </TableContainer>
  );
}
